import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import { isError } from "../../state/helpers/Error"
import { Intl } from "../../state/helpers/IntlProps"
import OnBoardingService from "../../state/onboarding/OnBoardingService"
import PaymentSetupWrapper from "../PaymentSetupWrapper"
import { ONBOARDING_STEP, getMainStep } from "../Steps"
import LoadingSetup from "../loadingsetup.component"
import VendRedirectSubscriptionComponent from "../vend/VendRedirectSubscriptionComponent"
import "../welcome.scss"
import InitialSetup from "./InitialSetup"
import SignUpSurveyContainer from "./SignUpSurveyContainer"
import StartUpGuideSurveyContainer from "./StartUpGuideSurveyContainer"

type OwnProps = {
    intl: Intl
    routeStep?: string
    continue?: boolean
}

const OnBoardingContainer = (props: OwnProps) => {
    const [currentStep, setCurrentStep] = useState<string>(ONBOARDING_STEP.INITIAL_STEP)

    useEffect(() => {
        if (props.routeStep) {
            setCurrentStep(props.routeStep)
            return
        }

        const account = AppContext.getAccount()
        if (account && account.attributes.onBoardingStep) {
            setCurrentStep(account.attributes.onBoardingStep)
            return
        }

    }, [])

    const onStepSubmit = (payload) => {
        OnBoardingService.ExecuteOnBoardingStep(currentStep, payload).then(res => {
            if (!isError(res) && res.step) {
                if (res.step)
                    setCurrentStep(res.step)
            }
        })
    }

    switch (getMainStep(currentStep)) {
    case ONBOARDING_STEP.ONLINE_PAYMENT_SETUP_STEP:
        return <PaymentSetupWrapper
            onStepCompleted={(payload) => { onStepSubmit(payload) }}
            continue={props.continue}
        />
    case ONBOARDING_STEP.SIGN_UP_SURVEY_STEP:
        return <SignUpSurveyContainer
            onStepCompleted={(payload) => { onStepSubmit(payload) }}
        />
    case ONBOARDING_STEP.START_UP_GUIDE_SURVEY_STEP:
        return <StartUpGuideSurveyContainer
            onStepCompleted={(payload) => { onStepSubmit(payload) }}
        />
    case ONBOARDING_STEP.VEND_ACTIVATE_WORKFLOWS_STEP:
        return <VendRedirectSubscriptionComponent
            onStepCompleted={(payload) => { onStepSubmit(payload) }}
        />
    case ONBOARDING_STEP.COMPLETE_ONBOARDING_STEP:
        return <LoadingSetup
            onStepCompleted={(payload) => { onStepSubmit(payload) }}
        />
    default:
        return <InitialSetup
            step={currentStep}
            onStepCompleted={(payload) => { onStepSubmit(payload) }}
        />
    }
}

export default injectIntl(OnBoardingContainer)


// WEBPACK FOOTER //
// ./src/onboarding/sections/OnBoardingContainer.tsx